<template>
  <div class="">
    <el-form :model="form" :rules="rules" ref="form">
      <TopBarTitleComponent title="Productos" :showBackIcon="showBackIcon">
        <template slot="right-area">
          <div class="d-flex justify-content-end align-items-center">
            <ButtonPrimaryComponent
              title="Guardar"
              @onSaveClick="handleSaveClick"
            />
            <button
              v-if="!showBackIcon"
              class="topbar-close-btn ml-3"
              @click="$emit('close')"
              title="Cerrar"
            >
              <i class="el-icon-close"></i>
            </button>
          </div>
        </template>
      </TopBarTitleComponent>

      <div class="dir-content-body">
        <b-row>
          <b-col xs="12" sm="12" md="6">
            <div class="card product-card">
              <div class="card-body">
                <el-form-item prop="image">
                  <FileUploadComponent
                    title="Subir imagen"
                    :preview="form.image"
                    :showFileList="false"
                    :drag="true"
                    @fileBase64="onFileBase64"
                  />
                </el-form-item>

                <el-form-item prop="name">
                  <slot name="label">
                    <label class="font-semi-bold m-0"
                      >Nombre del Servicio / Producto</label
                    >
                  </slot>
                  <el-input type="text" v-model="form.name"></el-input>
                </el-form-item>
                <b-row>
                  <b-col xs="12" sm="6">
                    <el-form-item prop="code">
                      <slot name="label">
                        <div
                          class="d-flex align-items-center justify-content-between"
                        >
                          <label class="font-semi-bold m-0">Código/SKU</label>
                          <a
                            href="javascript:;"
                            class="generate-code-link"
                            @click="onGenerateSequentialCode"
                          >
                            <i class="el-icon-refresh"></i> Generar
                          </a>
                        </div>
                      </slot>
                      <el-input type="text" v-model="form.code"></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col xs="12" sm="6">
                    <el-form-item prop="alternative_code">
                      <slot name="label">
                        <div
                          class="d-flex align-items-center justify-content-between"
                        >
                          <label class="font-semi-bold m-0"
                            >SKU alternativo</label
                          >
                          <a
                            href="javascript:;"
                            class="generate-code-link"
                            @click="onGenerateAlternativeCode"
                          >
                            <i class="el-icon-refresh"></i> Generar
                          </a>
                        </div>
                      </slot>
                      <el-input
                        type="text"
                        v-model="form.alternative_code"
                        placeholder="Opcional"
                      ></el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item prop="amount">
                  <slot name="label">
                    <label class="font-semi-bold m-0">Precio</label>
                  </slot>
                  <InputAmount
                    :amount="form.amount"
                    @onChange="amount => onInputAmount(amount, 'amount')"
                  />
                </el-form-item>
                <el-form-item prop="taxes_id">
                  <slot name="label">
                    <label class="font-semi-bold m-0">IVA</label>
                  </slot>
                  <SelectTaxes
                    :setTaxesId="form.taxes_id"
                    @onSelectTax="onSelectTax"
                  />
                </el-form-item>
                <el-form-item prop="categories_id">
                  <SelectCategories
                    :setSelectCategories="form.categories_id"
                    @onChangeSelect="onChangeSelectCategories"
                  />
                </el-form-item>
                <el-form-item prop="description">
                  <InputTextComponent
                    maxlength="null"
                    :showWordLimit="false"
                    inputProp="description"
                    @onInputChange="onInputChange"
                    :value.sync="form.description"
                  >
                    <template slot="label">
                      <label class="font-semi-bold m-0"
                        >Descripción del servicio</label
                      >
                      <span class="field-subtitle"
                        >Detalle a visualizar en documentos</span
                      >
                    </template>
                  </InputTextComponent>
                </el-form-item>
              </div>
            </div>
          </b-col>

          <b-col xs="12" sm="12" md="6" class="mt-4 mt-md-0">
            <div class="card product-card mb-4">
              <div class="card-body">
                <h5
                  class="h5 text-color-primary font-semi-bold line-bottom pb-2"
                >
                  Tipo de Producto
                </h5>
                <el-form-item prop="type">
                  <el-select v-model="form.type" placeholder="Seleccionar">
                    <el-option
                      v-for="(option, index) in productTypesCrear"
                      :key="index"
                      :label="option.label"
                      :value="option.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>

            <div class="card product-card mb-4">
              <div class="card-body">
                <h5
                  class="h5 text-color-primary font-semi-bold line-bottom pb-2"
                >
                  Estado de Producto
                </h5>
                <el-form-item prop="status_product">
                  <SwitchStatus
                    :setValue.sync="form.status_product"
                    @onStatus="onStatusProduct"
                  />
                </el-form-item>
              </div>
            </div>

            <TransitionFadeComponent>
              <ProductVariations
                v-if="form.type === 'variable'"
                @onSaveVariations="onSaveVariations"
              />
            </TransitionFadeComponent>

            <TransitionFadeComponent>
              <div class="card product-card mb-4" v-if="form.type === 'simple'">
                <div class="card-body">
                  <h5
                    class="h5 text-color-primary font-semi-bold line-bottom pb-2"
                  >
                    Gestión de inventario
                  </h5>
                  <TransitionFadeComponent
                    v-for="(stock, index) in form.stocks"
                    :key="index"
                  >
                    <el-form-item prop="stock" v-if="form.is_stock_counter">
                      <slot name="label">
                        <label class="font-semi-bold m-0">
                          {{ stock.establishment }}
                        </label>
                      </slot>
                      <el-input-number
                        :controls="false"
                        :min="0"
                        placeholder="Cantidad"
                        v-model="form.stocks[index].quantity"
                      ></el-input-number>
                    </el-form-item>
                  </TransitionFadeComponent>

                  <el-form-item prop="is_stock_counter">
                    <SwitchTracking
                      :setValue.sync="form.is_stock_counter"
                      @onTracking="onTrackingProduct"
                    />
                  </el-form-item>
                </div>
              </div>
            </TransitionFadeComponent>
          </b-col>
        </b-row>
      </div>
    </el-form>
  </div>
</template>

<script>
import TopBarTitleComponent from "../../../components/TopBarTitle";
import ButtonPrimaryComponent from "../../../components/ButtonPrimary";
import FileUploadComponent from "../../../components/FileUpload";
import Validate from "@/assets/validate";
import catalogueService, {
  productTypesCrear
} from "../../services/catalogueService";
import InputTextComponent from "../../../components/InputText";
import SelectTaxes from "./SelectTaxes";
import SelectCategories from "../../../components/SelectCategories";
import ProductVariations from "./Variations";
import TransitionFadeComponent from "@/components/Transitions/Fade";
import SwitchTracking from "./SwitchTracking";
import SwitchStatus from "./SwitchStatus";
import InputAmount from "@/components/General/InputAmount";
import tradeService from "../../../profile/services/tradeService";

export default {
  name: "ProductAddComponent",
  data() {
    return {
      productTypesCrear,
      apiResponse: {
        message: null
      },
      form: {
        categories_id: [],
        name: "",
        description: "",
        code: "",
        alternative_code: "",
        amount: 0,
        stocks: [],
        is_stock_counter: false,
        status_product: false,
        image: "",
        taxes_id: null,
        type: "simple",
        variations: []
      },
      rules: {
        name: [Validate.rules.required()],
        code: [Validate.rules.required()],
        taxes_id: [Validate.rules.required()],
        amount: [Validate.rules.numeric("number")]
        //categories_id: [Validate.rules.required("change")]
        // stock: [Validate.rules.numeric("integer")],
        // description: [Validate.rules.required()]
      },
      stablishments: []
    };
  },
  computed: {
    getModuleCatalog() {
      const { product } = this.$store.getters.getModule("catalog");
      return product.add;
    }
  },
  methods: {
    onFileBase64(base64) {
      this.form.image = base64;
    },
    onChangeInput(data) {
      this.form = { ...this.form, ...data };
    },
    onInputAmount({ amount }, key) {
      this.form[key] = amount;
    },
    onInputChange(value) {
      this.form.description = value;
    },
    onTrackingProduct({ tracking }) {
      this.form.is_stock_counter = tracking;
    },
    onStatusProduct({ status }) {
      this.form.status_product = status;
    },
    onChangeSelectCategories({ selectCategories }) {
      this.form.categories_id = selectCategories;
    },
    onSelectTax({ id }) {
      this.form.taxes_id = id;
    },
    onSaveVariations({ variations }) {
      this.form.variations = variations;
    },
    handleSaveClick() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.$store.dispatch("toggleRequestLoading");
          try {
            let response = await catalogueService
              .addProducts(this.form)
              .finally(() => {
                this.$store.dispatch("toggleRequestLoading");
              });
            const { success, message, product } = response.data;
            if (success) {
              this.$refs.form.resetFields();
              this.onFileBase64("");

              this.$notifications.success({
                message
              });

              this.$emit("onSuccess", { product });
            }
          } catch (error) {
            return false;
          }
        }
      });
    },
    async getStablishments() {
      try {
        const response = await tradeService.getStablishments();
        const establishmentsData = response.data?.data || [];
        this.stablishments = establishmentsData;

        this.form.stocks = establishmentsData.reverse().map(element => ({
          establishment: element.name,
          establishment_id: element.id,
          quantity: 0
        }));
      } catch (error) {
        return false;
      }
    },
    autoSelectSingleOption() {
      // Si hay solo una opción, selecciona automáticamente esa opción
      if (this.productTypesCrear.length === 1) {
        this.form.type = this.productTypesCrear[0].value;
      }
    },
    generateAlternativeSku() {
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let result = "ALT-";
      for (let i = 0; i < 6; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return result;
    },
    async onGenerateSequentialCode() {
      try {
        const response = await catalogueService.getProducts({
          params: { per_page: 1 }
        });
        const total =
          (response.data && response.data.total) ||
          (response.data && response.data.data && response.data.data.length) ||
          0;
        const next = total + 1;
        this.form.code = "PROD-" + String(next).padStart(5, "0");
      } catch (error) {
        const timestamp = Date.now()
          .toString()
          .slice(-6);
        this.form.code = "PROD-" + timestamp;
      }
    },
    onGenerateAlternativeCode() {
      this.form.alternative_code = this.generateAlternativeSku();
    }
  },
  components: {
    TopBarTitleComponent,
    ButtonPrimaryComponent,
    FileUploadComponent,
    InputTextComponent,
    SelectCategories,
    ProductVariations,
    TransitionFadeComponent,
    SwitchTracking,
    SwitchStatus,
    InputAmount,
    SelectTaxes
  },
  props: {
    showBackIcon: {
      default: true,
      type: Boolean
    }
  },
  mounted() {
    this.form = this.getModuleCatalog;
    this.getStablishments();
    this.autoSelectSingleOption();
  }
};
</script>

<style lang="scss" scoped>
.topbar-close-btn {
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #909399;
  transition: all 0.15s;

  &:hover {
    background: #f0f2f7;
    color: #31355c;
  }
}

.product-card {
  border: 1px solid #e8ecf2 !important;
  border-radius: 10px !important;
  box-shadow: none !important;
}

.field-subtitle {
  display: block;
  font-size: 11px;
  color: #989aae;
  font-weight: 400;
  margin-top: 2px;
  margin-bottom: 6px;
  line-height: 1.3;
}

.generate-code-link {
  font-size: 12px;
  color: #3ecfb4;
  text-decoration: none;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  transition: color 0.15s;

  &:hover {
    color: #1d9e75;
    text-decoration: none;
  }

  i {
    font-size: 13px;
  }
}
</style>
